<template>
  <span class="wloading">
    <img v-for="(n, key) in numbers" v-bind:key="key" src="@/assets/loading.gif" class="loading">
  </span>
</template>
<script>
export default {
  name: 'DisplayWaiting',
  props: {
    length: {
      type: [Number, String],
      default: 4
    }
  },
  computed: {
    numbers() {
      return new Array(+this.length)
    }
  }
}
</script>
<style lang="scss" scoped>
.wloading {
  img {
    width: 18px;
    margin: 0 2px;
  }
}
</style>
